{
  "login": {
    "seo": {
      "title": "School Login",
      "description": "Sign in to the CuriPop school portal."
    },
    "title": "School Portal Login",
    "subtitle": "Use your school staff credentials to continue.",
    "emailPlaceholder": "Email address",
    "passwordPlaceholder": "Password",
    "submit": "Sign in",
    "signingIn": "Signing in...",
    "errors": {
      "failed": "Login failed"
    }
  }
}
